export enum ContractAnalysisTypes {
  GET_CONTRACT_ANALYSIS_REQUEST = '@contracts/GET_CONTRACT_ANALYSIS_REQUEST',
  GET_CONTRACT_ANALYSIS_SUCCESS = '@contracts/GET_CONTRACT_ANALYSIS_SUCCESS',
  GET_CONTRACT_ANALYSIS_FAILURE = '@contracts/GET_CONTRACT_ANALYSIS_FAILURE',
  DETAILED_CONTRACT_ANALYSIS_REQUEST = '@contracts/DETAILED_CONTRACT_ANALYSIS_REQUEST',
  DETAILED_CONTRACT_ANALYSIS_SUCCESS = '@contracts/DETAILED_CONTRACT_ANALYSIS_SUCCESS',
  DETAILED_CONTRACT_ANALYSIS_FAILURE = '@contracts/DETAILED_CONTRACT_ANALYSIS_FAILURE',
  GET_INFO_BIDDING_REQUEST = '@contracts/GET_INFO_BIDDING_REQUEST',
  GET_INFO_BIDDING_SUCCESS = '@contracts/GET_INFO_BIDDING_SUCCESS',
  GET_INFO_BIDDING_FAILURE = '@contracts/GET_INFO_BIDDING_FAILURE',
  VALIDATE_CONTRACT_REQUEST = '@contracts/VALIDATE_CONTRACT_REQUEST',
  VALIDATE_CONTRACT_SUCCESS = '@contracts/VALIDATE_CONTRACT_SUCCESS',
  VALIDATE_CONTRACT_FAILURE = '@contracts/VALIDATE_CONTRACT_FAILURE',
}

export interface BiddingItem {
  id: number;
  orgao_nome: string;
  edital: string;
  modalidade: string;
}

export interface ClausesItem {
  descricao: string;
  impacto: string;
}
export interface DivergenceItem {
  clausula_referencia: string;
  contrato_recebido: string;
  descricao_divergencia: string;
  impacto: string;
  minuta_edital: string;
}

export interface ContractsAnalysisItemTypes {
  id: number;
  client_id: number;
  user_id: number;
  bidding_number: string;
  modality: string;
  organization: string;
  created_at: string;
  law: string | number;
  status: 'completed' | 'pending' | 'error';
  analysis_result: {
    resumo_executivo: {
      total_clausulas_ausentes: number;
      total_divergencias: number;
      nivel_risco: string;
    };
    divergencias: DivergenceItem[];
    clausulas_ausentes: ClausesItem[];
  };
}

export interface ContractsAnalysisTypes {
  list_contract_analysis: ContractsAnalysisItemTypes[];
  detailed_contract: ContractsAnalysisItemTypes | null;
  bidding: BiddingItem | null;
  currentPage: number;
  total_entries: number;
}
export interface BaseRequestState {
  loading: boolean;
  loaded: boolean;
  error: boolean;
}

export interface RequestState {
  list_contract_analysis: BaseRequestState;
  detailed_contract: BaseRequestState;
  bidding: BaseRequestState;
  validate_contract: BaseRequestState;
}

export interface ContractsAnalysisState {
  contract_analysis: ContractsAnalysisTypes;
  readonly request: RequestState;
}
